import styled, { css } from 'styled-components';
import { DeprecatedIcon as Icon } from '@aon-coverwallet/cw-react-components';

export const StyledUserCard = styled.div(
  ({ backgroundColor, theme: { colors, sizes } }) => css`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 6px 12px;
    font-weight: 500;
    border-radius: 7px;
    background: ${backgroundColor
      ? backgroundColor
      : colors.brand.primary.dark};

    @media (max-width: ${sizes.tablet}) {
      width: 100%;
      display: flex;
      flex-direction: column;
      border-radius: 0;
    }
  `,
);

export const StyledPrimarySection = styled.div`
  display: flex;
  align-items: center;
`;

export const StyledUserIcon = styled(Icon)`
  width: 24px;
  margin-right: 18px;
  overflow: visible !important;
`;

export const StyledCardInfoContainer = styled.div`
  min-width: 180px;
  line-height: 17px;
`;

export const StyledCardTitle = styled.div`
  font-size: 13px;
  color: ${({ theme: { colors } }) => colors.white};
`;

export const StyledCardDescription = styled.div`
  font-size: 12px;
  color: #8eccf1;
`;
